import "./TextField.scss";

/**
 * Controlled labeled text input for Plan Manager forms. Pure presentational —
 * emits intent through callbacks; owns no state. Always renders type="text".
 *
 * @param {object} props
 * @param {string} props.id - Input id; links label via htmlFor.
 * @param {string} props.label - Visible label text.
 * @param {string} props.value - Controlled input value.
 * @param {(value: string) => void} props.onChange - Emits the new string value.
 * @param {string} [props.placeholder] - Input placeholder.
 * @param {string} [props.helperText] - Optional hint below the input.
 * @param {string} [props.error] - Optional error message with role="alert".
 * @param {boolean} [props.disabled] - Disables the input.
 * @param {number} [props.maxLength] - Maximum character length.
 * @param {string} [props.className] - Extra class on the root element.
 * @returns {import('react').JSX.Element}
 */
const TextField = ({
    id,
    label,
    value,
    onChange,
    onBlur,
    placeholder,
    helperText,
    error,
    disabled,
    maxLength,
    className,
}) => {
    const rootClassName = [
        "form-input",
        "plan-manager-text-field",
        error ? "plan-manager-text-field--error" : null,
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={rootClassName}>
            <label htmlFor={id}>{label}</label>
            <input
                id={id}
                type="text"
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                onChange={(event) => onChange(event.target.value)}
                onBlur={onBlur}
            />
            {helperText ? (
                <p className="plan-manager-text-field__helper">{helperText}</p>
            ) : null}
            {error ? (
                <p className="plan-manager-text-field__error" role="alert">
                    {error}
                </p>
            ) : null}
        </div>
    );
};

export default TextField;
